import { Button } from '@cutilei/ui'
import layoutOf from 'utils/layoutStyle'

/*
  O miolo do MainButton e do SecondaryButton, sobre o Button do @cutilei/ui, no tamanho `sm` (36 px).

  - É um `<button>` de verdade, de tipo `button` por padrão, e não o `submit` do navegador: a maioria
    dos formulários do site não tem `onSubmit`, e um `submit` ali recarregaria a página. O envio vem
    do `onClick`, e o Enter nos campos vem do `submitOnEnter` do formulário;
  - bloqueado ou carregando, fica `disabled`: é justamente quando um segundo clique reenviaria a
    mesma operação. Carregando, a lib troca o ícone pelo spinner e põe `aria-busy`;
  - `width` (em px) vira a largura. Do `style`, valem só as chaves de layout;
  - `leftIcon` é um elemento do react-icons, com 16 px, antes do texto. Sem `label`, o botão é só o
    ícone, e a tela passa o `aria-label`. Ele continua sendo um Button, e não o IconButton da lib,
    que no `primary` é um círculo cinza e tiraria o destaque da ação principal.
*/
const ICON_SLOT = { display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: 24, fontSize: 16 }

export default function AdaptedButton({
  variant,
  destructive = false,
  label = '',
  width,
  leftIcon = null,
  loading = false,
  disabled = false,
  type = 'button',
  style,
  ...props
}) {
  return (
    <Button
      {...props}
      variant={variant}
      destructive={destructive}
      size='sm'
      type={type}
      loading={loading}
      disabled={disabled}
      style={{ ...layoutOf(style), ...(width != null && { width }) }}
    >
      {leftIcon && !loading && (
        // A linha do texto (24 px): um ícone maior, como a seta de 30 px do cadastro, transborda
        // dela sem mudar a altura do botão, que fica em 36 com ou sem texto.
        <span aria-hidden style={ICON_SLOT}>{leftIcon}</span>
      )}
      {label !== '' && label != null && <span className='px-1'>{label}</span>}
    </Button>
  )
}
